import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about";
import Programs from "../pages/programs";
import Admissions from "../pages/admissions";
import Contact from "../pages/contact";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nosotros",
    element: <About />,
  },
  {
    path: "/programas",
    element: <Programs />,
  },
  {
    path: "/admisiones",
    element: <Admissions />,
  },
  {
    path: "/contacto",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;